import {useEffect, useMemo, useRef, useState} from "react";
import './Remarks.css'
import PopUp from '.././PopUp/PopUp';
import Input from '.././Input/Input';
import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../HttpService/HttpService';
import DatePickerCustom from "../DatePickerCustom/DatePickerCustom";
import {DocumentOnList, Documents} from '../documents';
import {
    addAttachmentsToPrevList,
    getAttachmentsOnList,
    getExcludedDocumentsIdsForJoining,
    serializeAttachmentsForSaving,
    serializeFromDocumentToAttachment,
    serializeInitialAttachmentsForForm,
    setAllAttachmentsAsRemoved,
    setAttachmentAsRemoved
} from '../documents/helpers';
import {getControlRemarksInfoSave} from "../../Properties/Properties";

export const RemarksDetail = ({
    number,
    data,
	documents,
    handleChangeRemarksIssueDate,
    handleChangeObjectionExists,
    handleChangeTextRemarks,
    remarksInfoSave,
    closeWindow,
    onlyPreview,
}) => {
    const postControlInfoDateRef = useRef();
    const postControlInfo = (data?.postControlDocuments && data.postControlDocuments[0]?.postControlInfo) || (documents && documents[0]?.postControlInfo);
    const [attachments, setAttachments] = useState([]);
    const attachmentsUrl = PropertyBucket.getControlRemarksInfoSave(postControlInfo.id)

    useEffect(() => {
        httpService.getServicePromise(attachmentsUrl, 'GET').then(attachmentsResponse => {
          setAttachments(serializeInitialAttachmentsForForm(
              attachmentsResponse ? attachmentsResponse : []
          ))
        })
    }, []);

    const issueDate = Date.parse(!onlyPreview
      ? data?.objectionIssueDate : postControlInfo?.objection?.issueDate);

    useEffect(() => {
      if (!issueDate) {
        setAttachments(prevVal => setAllAttachmentsAsRemoved(prevVal));
      }
    }, [issueDate]);

    function handleRemoveAttachment(documentId) {
      if (onlyPreview) { return }
      // Attention! It is only removed from the list (mark as `toRemove`.
      // It's needed to save remarks if user wants to unattached the document
      // from remarks.
      setAttachments(prevVal => setAttachmentAsRemoved(prevVal, documentId));
    }

    function handleAddAttachments(documentList) {
      if (!documentList) { return }

      const attachments = documentList.map(
        document => serializeFromDocumentToAttachment(document));

      // Attention! It is only added to the list. It's needed to save remarks
      // if user wants to attached the document to remarks.
      setAttachments(prevVal => addAttachmentsToPrevList(prevVal, attachments));
    }

    function handleSaveRemark(ev) {
      remarksInfoSave(serializeAttachmentsForSaving(attachments));
    }

    // attachmentsOnList - only if "toRemove" is set to false for a document
    const attachmentsOnList = useMemo(
      () => getAttachmentsOnList(attachments), [attachments]);

    return (
        <div id='editWindowTab'><h4>Dotyczy kontroli {number}</h4>
            <div className='row'>
                <div className='col-md-6 objection-date'>
                    <DatePickerCustom
                        datePickerId='datePickerRemarks'
                        className='data-picker'
                        selected={issueDate}
                        label='Data otrzymania zastrzeżeń'
                        dateName='zgłoszenia zastrzeżeń'
                        labelClassName='mt-3 font-weight-bold'
                        onChange={handleChangeRemarksIssueDate}
                        disabled={onlyPreview || !data?.objectionExists}
                        parentRef={postControlInfoDateRef}
                    />
                </div>
                <div className='col-md-6 font-weight-bold positionCheck'>
                    <input
                        type='checkbox'
                        id='checkNoComments'
                        checked={onlyPreview ? !postControlInfo?.objection?.objectionExists : !data?.objectionExists }
                        className='markCheck'
                        onChange={(event) => handleChangeObjectionExists && handleChangeObjectionExists(!event.target.checked)}
                        disabled={onlyPreview || data?.objectionIssueDate}
                    />
                    <label htmlFor='checkNoComments' className='labelCheckbox'>Nie zgłoszono zastrzeżeń</label>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    {!onlyPreview && <p className='mt-3 font-weight-bold'>Dodaj zastrzeżenia</p>}
                    {attachmentsOnList.map(attachment =>
                      <DocumentOnList
                        canRemove={!onlyPreview}
                        document={attachment.document}
                        key={attachment.document.id}  // attachment can not have id yet
                        onlyRemoveFromList
                        onRemoveDocument={handleRemoveAttachment}
                      />
                    )}
                    {!onlyPreview &&
                      <div id='fileUpload'>
                        <Documents
                          controlUuid={data.record.uuid}
                          disabled={!issueDate}
                          excludedDocumentsIdsForJoining={
                            getExcludedDocumentsIdsForJoining(attachmentsOnList)
                          }
                          projectUuid={data.record.project.metadata.uuid}
                          onAddSuccess={handleAddAttachments}
                        />
                      </div>
                    }
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <Input
                        textareaNative
                        className='remarks-comment'
                        label='Uwagi'
                        labelClassName='mt-3 font-weight-bold'
                        inputId='commentsArea'
                        rows="5"
                        value={!onlyPreview ? data?.textRemarks : postControlInfo?.objection?.remarks}
                        onChange={(event) => setTimeout(handleChangeTextRemarks && handleChangeTextRemarks(event.target.value), 2000)}
                        disabled={onlyPreview}
                        maxLength={1000}
                        chartsCount={!onlyPreview ? data?.textRemarks?.length : postControlInfo?.objection?.remarks?.length || 0}
                    />
                </div>
            </div>
            {!onlyPreview && (<div className='btn_group mb-2'>
                <button className='btn save-btn' id='save_button' onClick={handleSaveRemark}>ZAPISZ</button>
                <button className='btn cancel-btn' onClick={() => closeWindow && closeWindow()}>ANULUJ</button>
            </div>)}
            {onlyPreview && (<div className='btn_group mb-2'>
                <button className='btn save-btn' id='save_button' onClick={() => closeWindow && closeWindow()}>OK</button>
            </div>)}
        </div>
    );
  };

  export const RemarksPopup = ({
    data,
	  documents,
    onlyPreview,
    closeWindow
  }) => {
      return (
        <PopUp
            customContent
            handleClosePopup={closeWindow}
            title='Informacje'
        >
            <RemarksDetail
                number={data.number}
                data={data}
				documents={documents}
                onlyPreview={onlyPreview}
                closeWindow={closeWindow}
            />
        </PopUp>
      );
  };
